module.exports = __webpack_public_path__ + "static/media/W19-1293_Mushroom_Mozza_Desktop_2396x1473_fr.f80dcaec.jpg";